'use strict';
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
defineWellKnownSymbol('split');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.split.js
// module id = 911
// module chunks = 0